<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  watch: {
    // $route (to) {
    //   document.title = to.meta.title
    // },
  },
  mounted () {
    var link = document.querySelector("link[rel*='icon']") || document.createElement('link')
    link.type = 'image/x-icon'
    link.rel = 'shortcut icon'
    link.href = '/static/favicon.ico'
    document.getElementsByTagName('head')[0].appendChild(link)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue